export default __webpack_public_path__ + "static/media/Mark-6-HUD-10.9b4b64a2.jpg";